;(function () {
  'use strict'

  angular
    .module('contrast.log-enhancer')
    .controller(
      'AddLogEnhancerCtrl',
      function AddLogEnhancerCtrl(
        $scope,
        $location,
        logEnhancerService,
        LanguagesService,
        UserService,
        LOG_ENHANCER_LEVELS,
        LOG_ENHANCER_TYPES
      ) {
        'ngInject'

        angular.extend($scope, {
          saveLog: saveLog,
          onLanguageChange: onLanguageChange,
          getLanguageDisplayValue: getLanguageDisplayValue
        })

        function init() {
          _initDefaults()
          _loadLanguages()
        }

        function _initDefaults() {
          angular.extend($scope, {
            levels: LOG_ENHANCER_LEVELS,
            types: LOG_ENHANCER_TYPES,
            log: {},
            settings: {}
          })

          angular.extend($scope.log, {
            level: LOG_ENHANCER_LEVELS.find(function (o) {
              return o.name === 'Info'
            }).value,
            type: LOG_ENHANCER_TYPES.find(function (o) {
              return o.name === 'Security'
            }).value
          })
        }

        function _loadLanguages() {
          $scope.languagePromise = logEnhancerService
            .getValidLanguages()
            .then(function (languages) {
              $scope.languages = languages
              $scope.log.language = $scope.languages[0]
            })
        }

        function saveLog() {
          angular.extend($scope.settings, {
            name: $scope.log.name,
            description: $scope.log.description,
            language: $scope.log.language,
            api: $scope.log.api,
            format: $scope.log.format,
            level: $scope.log.level,
            type: $scope.log.type
          })

          return logEnhancerService
            .addLogEnhancer($scope.settings)
            .then(function () {
              $location.path(UserService.buildUrl('/rules/log'))
            })
        }

        function onLanguageChange() {
          $scope.log.api = ''
        }

        function getLanguageDisplayValue(languageKey) {
          return LanguagesService.getLanguage(languageKey).display
        }

        init()
      }
    )
})()
